import { render, staticRenderFns } from "./app-home-recommend-coupon.vue?vue&type=template&id=de60db70"
import script from "./app-home-recommend-coupon.vue?vue&type=script&lang=js"
export * from "./app-home-recommend-coupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports